module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/5ukpFu/Images/cover.jpg?1685327487330",
      "alt": "This image is the cover for the book Salvare Sean, Storie di Seattle"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Salvare Sean, Storie di Seattle\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_c('b', [_c('i', [_vm._v("Un libro della serie Storie di Seattle")])])]), _c('p', [_vm._v("Quasi un anno dopo essere stato rifiutato per un altro, il paramedico di Seattle Peter Morse soffre ancora, ma quando l’uomo che lo ha respinto gli chiede un favore, acconsente. La sua missione: rintracciare Sean Reid, il fratello in fuga di un’amica comune. Peter non ne è entusiasta, finché non trova Sean ferito sul ciglio della strada.")]), _vm._v(" "), _c('p', [_vm._v("Tutto in Sean suscita gli istinti protettivi di Peter – salvare la gente è quello per cui vive – ma non aveva previsto di perdere la testa per una persona così decisa a scappare. Oltre alle ferite fisiche, Sean combatte contro il dolore e il senso di colpa, e il caos che il padre eremita ha lasciato dopo la sua morte minaccia di sopraffarlo.")]), _vm._v(" "), _c('p', [_vm._v("Salvare Sean vuol dire per Peter abbandonare il proprio orgoglio e rivolgersi ad amici e parenti. Chiedere aiuto è una pillola amara da ingoiare per Peter, ma se lui non riesce a farlo, come può aspettarsi che Sean accetti a sua volta il suo aiuto… e il suo amore?")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Con Riley, Rebecca Cornia\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0